export default __webpack_public_path__ + "static/media/Lifespan-37000PackshotFront34rgb500x500.a6440445.png";